import './activity_report_view.js.coffee';# Added by Script 
import './exportable_report_view.js.coffee'
Namespace 'Customer.Views.Insights'

class Customer.Views.Insights.MyActivityReportView extends Customer.Views.Insights.ActivityReportView
  jobURL: 'my_activity/report_job'
  infoURL: 'my_activity/info_before_execution'
  events:
    'click #filter': '_startActivityReportJob'
    'click #activity-export-excel': '_startActivityReportExcelJob'
    'click #export-confirm': 'exportConfirm'

  _startActivityReportJob: (event) ->
    event.preventDefault()
    return unless @_validateDates()
    @showLoadingAnimation()
    @activityReportJob(data: @serializeData(@$el)).start()

  _startActivityReportExcelJob: (event) ->
    event.preventDefault()
    return unless @_validateDates()
    @showLoadingAnimation()
    @activityReportExcelJob(data: @serializeData(@$el))

  _validateDates: ->
    date_from = new Date($('#from').val())
    date_to = new Date($('#to').val())
    time_period = 92
    difference_in_time = date_to.getTime() - date_from.getTime()
    difference_in_days = difference_in_time / (1000 * 3600 * 24)
    threeMonthsGap = difference_in_days <= time_period
    if !threeMonthsGap then errorMessage = @_optionsErrorMessage('threeMonthsGap')
    validRelativity = difference_in_days >= 0
    if !validRelativity then errorMessage = @_optionsErrorMessage('validRelativity')
    untilToday = date_to <= moment().toDate()
    if !untilToday then errorMessage = @_optionsErrorMessage('untilToday')
    if errorMessage
      swal(
        '',
        errorMessage,
        'error'
      )
    !errorMessage

  _optionsErrorMessage: (optionsError) =>
    messages = {
      threeMonthsGap: I18n.t('customer.reports.my_activity_report.wrong_parameters.three_months_gap')
      validRelativity: I18n.t('customer.reports.my_activity_report.wrong_parameters.dates_relativity')
      untilToday: I18n.t('customer.reports.my_activity_report.wrong_parameters.until_today')
    }
    messages[optionsError]

  setUpDrillDownLinks: =>
    @drillDownView.remove() if @drillDownView
    @drillDownView = new Customer.Views.Insights.MyActivityDrillDownView @serializeData(@$el)
